// extracted by mini-css-extract-plugin
module.exports = {"selectedPage":"Paginator_selectedPage__1Ja1i","allPages":"Paginator_allPages__3jFUe","button":"Paginator_button__1x7_Q"};